
import crypto from '../assets/svg/projects/Crypto-Stalker.png'
import demoportfolio from '../assets/svg/projects/Demoportfolio.png'
import gamex from '../assets/svg/projects/Games - X.png'
import texteditor from '../assets/svg/projects/TextEditor.png'
import covid19 from '../assets/svg/projects/covid19.png'
import wingusecurity from '../assets/svg/projects/wingusecurity.png'
import winguenterprises from '../assets/svg/projects/winguenterprises.png'

export const projectsData = [
    {
        id: 1,
        projectName: 'Cyrpto Stalker',
        projectDesc: 'This project seeks to explore cryptos price with up and down in market. Its helps you to see real time market up and down in cryptos. Here i used API to fetch data.',
        tags: ['HTML' ,'CSS', 'Javascript','REACT','API'],
        code: 'https://github.com/SIMRAT007/Crypto-Stalker',
        demo: 'https://crypto-stalker-pro.netlify.app',
        image: crypto
    },
    {
        id: 2,
        projectName: 'Demo - PortFolio',
        projectDesc: 'Its simply a demo portfolio website, built with the help of HTML, CSS and JavaScript. Its simply show you the UI/UX work done by me. It has very beautiful UI to interact. ',
        tags: ['HTML', 'CSS','Javascript'],
        code: 'https://github.com/SIMRAT007/simratsingh.github.io',
        demo: 'https://simrat007.github.io/simratsingh.github.io/',
        image: demoportfolio
    },
    {
        id: 3,
        projectName: 'Games - X',
        projectDesc: 'This is the clone of reliancedigital.in. Features I worked on the Product Catalogue pages and also on some minor parts on other pages as well',
        tags: ['REACT','HTML','CSS','JavaScript','API'],
        code: 'https://github.com/SIMRAT007/Game-X',
        demo: 'https://games-x.netlify.app/',
        image: gamex
    },
    {
        id: 4,
        projectName: 'Text Editor',
        projectDesc: 'TextEditor is a free character counter tool that provides instant character count & word count statistics for a given text. TextUtils reports the number of words and characters. Thus it is suitable for writing text with word/ character limit..',
        tags: ['HTML', 'CSS', 'Javascript', 'React'],
        code: 'https://github.com/SIMRAT007/TextEditor',
        demo: 'https://textblue-penciler.netlify.app/',
        image: texteditor
    },

    {
        id: 5,
        projectName: 'COVID - TMS',
        projectDesc: 'This website is for covid vaccination registration. A very simple website using php, css, html and javascript.',
        tags: ['HTML', 'CSS','PHP','MYSQL'],
        code: 'https://github.com/SIMRAT007/covid19-TMS',
        demo: '',
        image: covid19
    },

    {
        id: 6,
        projectName: 'WINGU SECURITY',
        projectDesc: 'This website is totally based on UI/UX as i just made UI/UX of this website and all the frontend and backend part is done by just drag and drop in WIX.',
        tags: ['WIX','UI', 'UX'],
        code: '',
        demo: 'https://www.wingusecurity.com/',
        image: wingusecurity
    },

    {
        id: 7,
        projectName: 'WINGU ENTERPRISES',
        projectDesc: 'This website is totally based on UI/UX as i just made UI/UX of this website and all the frontend and backend part is done by just drag and drop in WIX.',
        tags: ['WIX','UI', 'UX'],
        code: '',
        demo: 'https://www.wingueeve.com/',
        image: winguenterprises
    },
    
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/